import { useEffect, useState } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import { Media } from '@atom/types/media';
import api from '@atom/utilities/api';
import { FILES_ENDPOINT, MEDIA_ENDPOINT } from '@atom/utilities/endpoints';
import { TOTAL_COUNT_HEADER } from '@atom/utilities/requestUtilities';

import classes from '../workOrderDetailPdfReport.module.css';

const MEDIA_LIMIT = 250;

const styles = {
  photoName: {
    width: '27rem',
    margin: '0 auto',
    textAlign: 'center',
  },
};

const sortByName = (first: any, second: any): number =>
  first.name.localeCompare(second.name, undefined, { numeric: true });

interface Props {
  workOrderId: string;
  setOtherPhotosLoading: (currentLoading: { [id: string]: boolean }) => void;
}

const PhotosBox = ({ workOrderId, setOtherPhotosLoading }: Props) => {
  const [photos, setPhotos] = useState<Media[]>([]);

  const getMediaPage = (page: number): Promise<Media[]> => {
    return api
      .get<Media[]>(MEDIA_ENDPOINT, {
        parentSubjectId: workOrderId,
        type: 'image',
        limit: MEDIA_LIMIT,
        page,
      })
      .then(res => res.data);
  };

  useEffect(() => {
    const getMedia = async () => {
      const response = await api.get(MEDIA_ENDPOINT, {
        parentSubjectId: workOrderId,
        type: 'image',
        page: 1,
        limit: MEDIA_LIMIT,
      });
      let totalPhotos = response.data;
      const total = Number(response.headers[TOTAL_COUNT_HEADER]);

      if (total > MEDIA_LIMIT) {
        const pages = Math.ceil(total / MEDIA_LIMIT);
        const promises: Array<Promise<Media[]>> = [];

        for (let index = 2; index <= pages; index++) {
          promises.push(getMediaPage(index));
        }

        const allRemainingPhotos = await Promise.all(promises);
        totalPhotos = [...totalPhotos, ...R.flatten(allRemainingPhotos)];
      }

      const sortedPhotos = R.sort(sortByName, totalPhotos);
      setPhotos(sortedPhotos);
      // @ts-ignore
      setOtherPhotosLoading(currentLoading => ({
        ...currentLoading,
        photoBox: false,
      }));
    };
    getMedia();
  }, []);

  useEffect(() => {
    if (photos.length) {
      photos.forEach(photo => {
        // @ts-ignore
        setOtherPhotosLoading(currentLoading => ({
          ...currentLoading,
          [photo.id]: true,
        }));
      });
    }
  }, [photos]);

  return (
    <>
      {!!photos.length && (
        <>
          <div className={classes.pageBreak} />
          <table className={classes.collapseBorder}>
            <thead>
              <tr>
                <th className={classes.textboxTableTitle}>Photos</th>
              </tr>
            </thead>
            <tbody className={classes.content}>
              <div className={classes.photosContainer}>
                {photos.map(photo => (
                  <div>
                    <div
                      className={clsx(classes.photoTile, classes.idl)}
                      key={photo.id}
                    >
                      <span className={classes.imgHelper} />
                      <img
                        className={classes.img}
                        src={`${FILES_ENDPOINT}/${photo.fileId}`}
                        onLoad={() => {
                          // @ts-ignore
                          setOtherPhotosLoading(loadingState => ({
                            ...loadingState,
                            [photo.id]: false,
                          }));
                        }}
                      />
                    </div>
                    <div style={styles.photoName}>{photo.name}</div>
                  </div>
                ))}
              </div>
            </tbody>
          </table>
        </>
      )}
    </>
  );
};

export default PhotosBox;
